angular.module('angus.services').factory("SubRegResource", [
    '$rootScope', '$resource', function($rootScope, $resource) {
        return $resource("api/subscribers/:subscriberId", { subscriberId: '@subscriberId' },
        {
            update: { method: 'PUT' }
        });
    }
])